const STREET_NAME = 'Calle'
const AVE_NAME = 'Avenida'

export const unique = (arr) => {
    return [...new Set(arr)]
}

export const elements_filtered = (elements = []) => {

    const street_ave_bag = []
    const streets_bag = []

    elements.forEach(element => {
        const name = element.tags?.name

        if(!name) return;

        const splitted = name.split(' ')

        if(splitted.length > 1 && splitted[0] == STREET_NAME || splitted[0] == AVE_NAME) {
            const street_type = splitted.shift()
            const name_without_street = splitted.join(' ')
            const stowaway = streets_bag.findIndex(s => s == name_without_street)

            if(stowaway != -1) {
                streets_bag.splice(stowaway, 1)
            }

            streets_bag.push(name)
            street_ave_bag.push(name_without_street)
        } else {
            if(!street_ave_bag.some(s => s == name)) streets_bag.push(name)
        }
    })

    return streets_bag
}

export const get_alternatives = (street) => {
    const noParenthesis = street.replace('(', '\\\\(').replace(')', '\\\\)')
    const splitted = noParenthesis.split(' ')

    if(splitted[0] != STREET_NAME && splitted[0] != AVE_NAME) {
        return [
            noParenthesis,
            `${STREET_NAME} ${noParenthesis}`,
            `${AVE_NAME} ${noParenthesis}`
        ]
    }

    if(splitted[0] == AVE_NAME) {

        splitted.shift()

        return [
            noParenthesis,
            splitted.join(' '),
            `${STREET_NAME} ${splitted.join(' ')}`
        ]
    }

    splitted.shift()

    return [
        noParenthesis,
        splitted.join(' '),
        `${AVE_NAME} ${splitted.join(' ')}`
    ]
}